import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const SeoSocial = ({
  url, description, title, imageUrl,
}) => {
  // set landing page default here
  const metaUrl = url || 'https://apps.bostonglobe.com/opinion/graphics/2022/05/covid-memorial';

  const metaDescription = description || 'As the United States nears its one millionth COVID-19 related death, artists, architects, and community leaders are calling for a permanent memorial to honor all those touched by COVID. Globe Opinion asked several artists for their vision of  what a COVID memorial could look like.';

  const metaTitle = 'How do we memorialize the pandemic?';

  const metaImage = imageUrl || 'https://apps.bostonglobe.com/opinion/graphics/2022/05/covid-memorial/images/share.jpg';

  return (
    <Helmet
      htmlAttributes={{
        lang: 'en-US',
      }}
      title={title}
      titleTemplate="%s - The Boston Globe"
      meta={[
        {
          name: 'description',
          content: metaDescription,
        },
        {
          property: 'og:title',
          content: metaTitle,
        },
        {
          property: 'og:description',
          content: metaDescription,
        },
        {
          property: 'og:url',
          content: metaUrl,
        },
        {
          property: 'og:image',
          content: metaImage,
        },
        {
          property: 'og:site_name',
          content: 'BostonGlobe.com',
        },
        {
          property: 'og:type',
          content: 'article',
        },
        {
          property: 'og:city',
          content: 'Boston',
        },
        {
          property: 'og:state',
          content: 'MA',
        },
        {
          property: 'og:country',
          content: 'US',
        },
        {
          property: 'fb:admins',
          content: '100001044693856,507486035',
        },
        {
          property: 'fb:app_id',
          content: '103933749691726',
        },
        {
          property: 'fb:pages',
          content: '5637143257',
        },
        {
          property: 'article:publisher',
          content: 'https://www.facebook.com/globe',
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'twitter:site',
          content: '@BostonGlobe',
        },
        {
          name: 'twitter:creator',
          content: '@BostonGlobe',
        },
        {
          name: 'twitter:title',
          content: metaTitle,
        },
        {
          name: 'twitter:description',
          content: metaDescription,
        },
        {
          name: 'twitter:image',
          content: metaImage,
        },
        {
          name: 'twitter:url',
          content: metaUrl,
        },
      ]}
      link={[
        {
          rel: 'icon',
          type: 'image/x-icon',
          href: 'https://www.bostonglobe.com/pf/resources/images/favicon.png?d=312',
        },
        {
          rel: 'apple-touch-icon',
          sizes: '180x180',
          href: 'https://www.bostonglobe.com/pf/resources/images/icons/apple-touch-icon.png?d=312',
        },
        {
          rel: 'icon',
          type: 'image/png',
          sizes: '32x32',
          href: 'https://www.bostonglobe.com/pf/resources/images/icons/favicon-32x32.png?d=312',
        },
        {
          rel: 'icon',
          type: 'image/png',
          sizes: '16x16',
          href: 'https://www.bostonglobe.com/pf/resources/images/icons/favicon-16x16.png?d=312',
        },
        {
          rel: 'mask-icon',
          href: 'https://www.bostonglobe.com/pf/resources/images/icons/safari-pinned-tab.svg?d=312',
          color: '#070707',
        },
      ]}
    />
  );
};

SeoSocial.defaultProps = {
  url: '',
  title: '',
  description: '',
  imageUrl: '',
};

SeoSocial.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
};

export default SeoSocial;
